export default "__VITE_ASSET__cfb5acfe__"